interface FetchOptions {
  timeout: number;
  retryCount: number;
}

const DEFAULT_TIMEOUT = 30_000;
const DEFAULT_RETRY_COUNT = 0;

export const runFetch = async (
  fetchFn,
  options: Partial<FetchOptions> = {},
) => {
  try {
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => {
        reject(new Error('Request timed out'));
      }, options.timeout || DEFAULT_TIMEOUT);
    });
    const response = await Promise.race([fetchFn(), timeoutPromise]);
    return response;
  } catch (err) {
    if (options.retryCount) {
      console.warn(
        `Retrying fetch due to error: ${(err as any)?.message}`,
        err,
      );
      return runFetch(fetchFn, {
        ...options,
        retryCount: options.retryCount - 1,
      });
    }
    // eslint-disable-next-line no-console
    console.log('runFetch.error, ', err);
    return Promise.reject(err);
  }
};

export const runFetchJson = async <Response = any,>(
  fetchFn,
  options: Partial<FetchOptions> = {},
): Promise<Response> => {
  try {
    const response = await runFetch(fetchFn, options);
    if (response && response.status === 201) return response;
    return response.json();
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('runFetchJson.error, ', err);
    return Promise.reject(err);
  }
};
